import { useContext } from "react";

import { DeveloperSettingsContext } from "../contexts";

export function useDeveloperSettings() {
  const context = useContext(DeveloperSettingsContext);

  return context;
}
